import { request, API_V1_PREFIX } from "./client";
import type { ActivityData } from "./types";

export async function getActivities(token: string, schoolProfileId?: string): Promise<ActivityData[]> {
  const query = schoolProfileId ? `?school_profile_id=${schoolProfileId}` : "";
  return request<ActivityData[]>(`${API_V1_PREFIX}/activities${query}`, { method: "GET" }, { token });
}

export async function createActivity(
  data: Omit<ActivityData, "id">,
  token: string,
): Promise<ActivityData> {
  return request<ActivityData>(
    `${API_V1_PREFIX}/activities`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    },
    { token },
  );
}

export async function updateActivity(id: string, data: Partial<ActivityData>, token: string): Promise<ActivityData> {
  return request<ActivityData>(
    `${API_V1_PREFIX}/activities/${id}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    },
    { token }
  );
}

export async function deleteActivity(id: string, token: string): Promise<boolean> {
  return request<boolean>(`${API_V1_PREFIX}/activities/${id}`, { method: "DELETE" }, { token });
}
